import { render, staticRenderFns } from "./AdminMenu.vue?vue&type=template&id=6a2c9798"
import script from "./AdminMenu.vue?vue&type=script&lang=ts"
export * from "./AdminMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports